import { LazyReactPlayer } from 'src/components/LazyReactPlayer';
import { VideoUpsell } from 'src/v2/components/ThreadMessage/components/VideoUpsell';
import { getRandomVideo } from 'src/utils';
import styles from './ThreadErrorVideoMessage.module.scss';
import { isMobile } from 'react-device-detect';

export const ThreadErrorVideoMessage = () => {
  const video = getRandomVideo();

  return (
    <div className={styles.root}>
      <LazyReactPlayer
        url={video}
        controls
        playing={!isMobile}
        className={styles.videoWrapper}
      />

      <VideoUpsell />
    </div>
  );
};
